/*
  CO2Art — the system builder engine (assets/system-builder.js), 2026-09-10.
  Loaded by sections/system-builder.liquid. The section renders every word; this file only shows and
  hides, clones rows from the section's row bank into the list and the review, fills numbers and
  prices (theme.Currency.formatMoney), and talks to the cart the way Concept's own product form does.

  VARIANT MATCHING RULES — the option values come from the live catalogue and are matched by
  lower-case substring (the products' option strings differ in spacing between the two regulators):
    regulator_se / regulator_elite   option "Connection": CGA320 wanted -> the variant whose value contains
                                     "cga320"; Europe wanted -> the one containing "bs341"
                                     (Pro-SE prints "BS341/DIN477/W21.8x14", Pro-Elite "BS341 / DIN477 / W21.8x14").
    adapter                          "Bottle Type" x "Outlet Type": exact match on both. Only combinations that
                                     exist as variants can be picked (2026-09-10: 5 of the 9 exist), and the
                                     regulator's connection FOLLOWS the outlet: contains "cga320" -> CGA320,
                                     anything else -> the BS341 family (Australia/Oceania W21.8x14 is that family).
    diffuser_bazooka / diffuser_io   "Size": the SKU's last part, S = small, L = large (FLUX-S/L, CA-IOD-AS-S/L); the value's
                                     "below"/"above" only as a fallback. Default from the tank answer: Bazooka large above
                                     250 L, IO large above 150 L.
    2026-09-12 (Shopify Markets): option values are translated on the market domains ("below 250L" is "poniżej 250L" on
    co2art.pl), so an English word in a value is never the key — the SKU is (the JSON carries it, sections/system-builder.liquid).
    diffuser_inline                  "Size": the button carries the variant id (12/16 vs 16/22).
    ubend                            "Size": the SKU's last part, S / M / L (A-UB-S/M/L); "1cm" / "1.5cm" / "2cm" in the value only
                                     as a fallback (spaces removed first). Default from the tank: small / medium / large.
    tubing                           "Color" x "Lenght" (sic - the catalogue spells the option that way): exact.
    everything else                  the first variant.
  A variant with available=false is shown as sold out, cannot be picked, and blocks the add.

  CART: one POST to theme.routes.cart_add_url with items[], each line tagged with the hidden property
  `_builder`; the same cart:bundled-sections -> cartUpdate publish -> cart-drawer.show() sequence as
  theme.js ProductForm. "Update" reads the cart, zeroes only the lines carrying `_builder` (by line
  item key, one /cart/update call), then adds again. Lines without `_builder` are never touched.
*/
(function () {
  'use strict';
  /* session 6 (2026-09-11): the builder also lives in a modal (snippets/builder-modal.liquid) — Concept re-creates this script tag on every
     injection, so the engine is one function per builder root: the first copy of the script owns boot(), later copies only boot the new root. */
  if (window.CO2BuilderBoot) { window.CO2BuilderBoot(); return; }
  function init(root) {
  var PRODUCTS;
  try { PRODUCTS = JSON.parse(root.querySelector('[data-builder-products]').textContent); } catch (e) { PRODUCTS = {}; }

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var T = window.theme || {};
  function money(cents) {
    try { return T.Currency.formatMoney(cents, T.settings.moneyFormat); } catch (e) { return (cents / 100).toFixed(2); }
  }
  function low(s) { return String(s == null ? '' : s).toLowerCase().trim(); }
  function q(v) { return String(v).replace(/["\\]/g, '\\$&'); }

  /* ── catalogue ─────────────────────────────────────────────────────────── */
  var ROLES = ['regulator_se', 'regulator_elite', 'manifold', 'adapter', 'diffuser_bazooka', 'diffuser_io', 'diffuser_inline', 'ubend', 'suction', 'tubing', 'dropchecker', 'solution', 'checkvalve', 'bubblecounter'];
  function vs(role) { var p = PRODUCTS[role]; return (p && p.variants) || []; }
  function find(role, pred) { var a = vs(role); for (var i = 0; i < a.length; i++) if (pred(a[i])) return a[i]; return null; }
  function first(role) { return vs(role)[0] || null; }
  function byId(role, id) { return find(role, function (v) { return String(v.id) === String(id); }); }
  function anyById(id) { for (var i = 0; i < ROLES.length; i++) { var v = byId(ROLES[i], id); if (v) return v; } return null; }
  function joinHas(v, s) { return low(v.o.join(' / ')).indexOf(s) !== -1; }

  function connWanted() {
    if (S.conn === 'us') return 'us';
    if (S.conn === 'alt') return /cga320/i.test(S.outlet || '') ? 'us' : 'eu';
    return 'eu';
  }
  function regVariant(role) {
    var w = connWanted();
    return find(role, function (v) { return w === 'us' ? joinHas(v, 'cga320') : joinHas(v, 'bs341'); }) || first(role);
  }
  function adapterVariant(b, o) {
    return find('adapter', function (v) { return low(v.o[0]) === low(b) && low(v.o[1]) === low(o); });
  }
  function adapterOutletsFor(bottle) {
    return vs('adapter').filter(function (v) { return low(v.o[0]) === low(bottle); });
  }
  function skuEnd(v) { return String((v && v.sku) || '').split('-').pop().toUpperCase(); }
  function diffDefault(which) {
    var role = which === 'bazooka' ? 'diffuser_bazooka' : 'diffuser_io';
    var big = which === 'bazooka' ? S.size === 'l' : S.size !== 's';
    var v = find(role, function (x) { return skuEnd(x) === (big ? 'L' : 'S'); })
      || find(role, function (x) { return joinHas(x, big ? 'above' : 'below'); }) || first(role);
    return v ? v.id : null;
  }
  function ubendDefault() {
    var code = S.size === 's' ? 'S' : (S.size === 'm' ? 'M' : 'L');
    var want = S.size === 's' ? '1cm' : (S.size === 'm' ? '1.5cm' : '2cm');
    var v = find('ubend', function (x) { return skuEnd(x) === code; }) || find('ubend', function (x) {
      var s = low(x.o[0]).replace(/\s+/g, '');
      if (want === '1cm') return s.indexOf('1cm') !== -1 && s.indexOf('1.5cm') === -1;
      return s.indexOf(want) !== -1;
    }) || first('ubend');
    return v ? v.id : null;
  }
  function tubingVariant() {
    return find('tubing', function (v) { return low(v.o[0]) === low(S.col) && low(v.o[1]) === low(S.len); });
  }

  /* ── state ─────────────────────────────────────────────────────────────── */
  var S = {
    size: null, conn: null, bottle: null, outlet: null, filter: null,
    reg: null, tanks: null, extra: 1,
    diff: null, dsize: null, dauto: true, hose: null,
    qty: { df: 1, tb: 1, ub: 1, sc: 1, dc: 1, sl: 1, cv: 1, sb: 1 }, dqauto: true,
    len: null, col: null, ubend: null, uauto: true, ubon: null, cups: true,
    drop: true, sol: true, valve: null, spare: false,
    seen: {}, cur: 'tank', added: false, inCart: false, busy: false
  };
  var STEPS = ['tank', 'cyl', 'filter', 'reg', 'diff', 'run', 'safe'];
  /* 2026-09-21: where the store fixes the cylinder thread (data-fixed-conn from settings.store_cylinder_thread — co2art.us = CGA320),
     the answer is preset and the "Where are you?" step leaves the flow (its markup is not rendered either) */
  var FIXED = (root.dataset && root.dataset.fixedConn) || '';
  if (FIXED) { S.conn = FIXED; STEPS = STEPS.filter(function (s) { return s !== 'cyl'; }); }
  function canister() { return S.filter === 'canister'; }
  function inlineOk() { return S.filter === 'canister' || S.filter === 'sump' || S.filter === 'none'; }   /* the inline diffuser needs a hose with flow: a canister's, a sump's return line, or whatever a buyer with no filter yet will run (Karol 2026-09-10) */
  function route() {
    if (S.diff) return S.diff === 'inline' ? 'inline' : 'tank';
    return S.filter ? (canister() ? 'inline' : 'tank') : null;
  }
  function aquariums() { return S.tanks === 'many' ? 1 + S.extra : 1; }

  /* ── DOM text helpers (the words always come from the page, never from here) ── */
  function clean(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    $$('.so, .sw, .mark, .box, .cost, .note, .why', c).forEach(function (x) { x.parentNode.removeChild(x); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function optEl(set, val) { return $('.opt[data-set="' + set + '"][data-val="' + q(val) + '"]'); }
  function chipEl(set, val) { return $('.chip[data-set="' + set + '"][data-val="' + q(val) + '"]'); }
  function optTitle(set, val) { var el = optEl(set, val); return el ? clean(el.querySelector('.name')) : ''; }
  function chipLabel(set, val) { var el = chipEl(set, val); return el ? clean(el.querySelector('.lab')) : ''; }
  function setText(scope, sel, text) { $$(sel, scope).forEach(function (e) { e.textContent = text; }); }

  /* ── the list: nothing is written before the buyer reaches the step that produces it ── */
  function spec() {
    var o = [], r = route();
    function part(key, row, step, variant, qty, v, extra) {
      var e = extra || {};
      var cents = variant ? variant.price * (qty || 1) : 0;
      o.push({ key: key, row: row, step: step, variant: variant, qty: qty || 1, v: v || '', cents: e.na ? 0 : cents,
        na: !!e.na, included: !!e.included, avail: e.na || e.included ? true : !!(variant && variant.available) });
    }
    if (S.size) o.push({ key: 'c1', row: 'c1', ctx: true, step: 'tank', val: optTitle('size', S.size) });
    if (S.conn && !FIXED) o.push({ key: 'c2', row: 'c2', ctx: true, step: 'cyl', val: optTitle('conn', S.conn) });
    if (S.filter) o.push({ key: 'c3', row: 'c3', ctx: true, step: 'filter', val: optTitle('filter', S.filter) });

    if (S.seen.cyl && S.conn === 'alt') {
      part('ad', 'ad', 'cyl', adapterVariant(S.bottle, S.outlet), 1, chipLabel('bottle', S.bottle) + ' · ' + chipLabel('outlet', S.outlet));
    }
    if (S.seen.reg && S.reg) {
      var el = S.reg === 'elite', rv = regVariant(el ? 'regulator_elite' : 'regulator_se');
      part('rg', el ? 'rg-el' : 'rg-se', 'reg', rv, 1, rv ? rv.o[0] : '');
      /* 2026-09-11 (the team): no summary row for the regulator's own bubble counter — its bank row is gone too */
      if (S.tanks === 'many') part('mf', 'mf', 'reg', first('manifold'), S.extra, '');
    }
    if (S.seen.diff) {
      if (S.diff === 'inline' && S.hose) part('df', 'df-in', 'diff', byId('diffuser_inline', S.hose), S.qty.df, chipLabel('hose', S.hose) + ' hose');
      if (S.diff === 'bazooka') part('df', 'df-bz', 'diff', byId('diffuser_bazooka', S.dsize), S.qty.df, chipLabel('dsize', S.dsize));
      if (S.diff === 'io') part('df', 'df-io', 'diff', byId('diffuser_io', S.dsize), S.qty.df, chipLabel('dsize', S.dsize));
    }
    if (S.seen.run) {
      if (S.len) part('tb', 'tb', 'run', tubingVariant(), S.qty.tb, optTitle('len', S.len) + ' · ' + chipLabel('col', S.col));
    }
    if (S.seen.safe) {
      if (r === 'tank') {
        if (S.ubon && S.ubend) part('ub', 'ub', 'safe', byId('ubend', S.ubend), S.qty.ub, chipLabel('ubend', S.ubend) + ' glass');
        if (S.cups) part('sc', 'sc', 'safe', first('suction'), S.qty.sc, '');
      } else {
        part('ub', 'ub-na', 'safe', null, 1, '', { na: true });
      }
      if (S.drop) part('dc', 'dc', 'safe', first('dropchecker'), S.qty.dc, '');
      if (S.sol) part('sl', 'sl', 'safe', first('solution'), S.qty.sl, '');
      if (S.valve) part('cv', 'cv', 'safe', first('checkvalve'), S.qty.cv, '');
      if (S.spare) part('sb', 'sb', 'safe', first('bubblecounter'), S.qty.sb, '');
    }
    return o;
  }
  function total(o) { var t = 0; for (var i = 0; i < o.length; i++) t += o[i].cents || 0; return t; }
  function partCount(o) { var n = 0; for (var i = 0; i < o.length; i++) if (!o[i].ctx && !o[i].na) n++; return n; }
  function cartItems(o) {
    return o.filter(function (r) { return !r.ctx && !r.na && !r.included && r.variant; })
      .map(function (r) { return { id: r.variant.id, quantity: r.qty, properties: { _builder: 'system' } }; });
  }
  function soldOut(o) {
    for (var i = 0; i < o.length; i++) if (!o[i].ctx && !o[i].na && !o[i].included && !o[i].avail) return true;
    return false;
  }

  /* what each step still needs before it counts as answered */
  function ok(id) {
    if (id === 'tank') return !!S.size;
    if (id === 'cyl') return !!S.conn && (S.conn !== 'alt' || !!adapterVariant(S.bottle, S.outlet));
    if (id === 'filter') return !!S.filter;
    if (id === 'reg') return !!S.reg && !!S.tanks;
    if (id === 'diff') return S.diff === 'inline' ? !!S.hose : !!S.diff && !!S.dsize;
    if (id === 'run') return !!S.len && !!S.col;
    return !!S.seen.safe;
  }
  function ready() { return ok('tank') && ok('cyl') && ok('filter') && ok('reg') && ok('diff') && ok('run'); }

  /* ── rendering ─────────────────────────────────────────────────────────── */
  function render() {
    if (S.cur !== 'done') {
      S.seen[S.cur] = true;
      if (S.cur === 'safe' && route() === 'tank' && S.ubend === null) { S.ubend = ubendDefault(); S.uauto = true; }
      if (S.cur === 'safe' && S.ubon === null) S.ubon = route() === 'tank';
      if (S.cur === 'safe' && S.valve === null) S.valve = route() === 'inline';
    }
    var o = spec(), i = STEPS.indexOf(S.cur);
    renderStep(o);
    if (S.cur === 'done') renderReview(o);
    renderList(o);
    renderBar(i, o);
    renderRoute();
    $('.stage').scrollTop = 0;
  }

  /* 2026-09-21: a step's photograph follows the chosen variant — the tubing card shows the roll in the chosen colour (the variant's own image from the
     products JSON), the product's featured image until a colour is picked */
  function renderPhoto() {
    $$('[data-photo-role]').forEach(function (fig) {
      var img = fig.querySelector('img'); if (!img) return;
      if (!fig.dataset.photoDefault) fig.dataset.photoDefault = img.getAttribute('src') || '';
      var role = fig.dataset.photoRole, v = null;
      if (role === 'tubing' && S.col) {
        v = find('tubing', function (x) { return low(x.o[0]) === low(S.col) && (!S.len || low(x.o[1]) === low(S.len)); }) || find('tubing', function (x) { return low(x.o[0]) === low(S.col); });
      }
      var src = (v && v.img) || fig.dataset.photoDefault;
      if (src && img.getAttribute('src') !== src) { img.style.opacity = '0.35'; img.onload = function () { img.style.opacity = ''; }; img.setAttribute('src', src); }
    });
  }
  /* 2026-09-23 (clean audit L1-08): when the step changes, focus moves to the new step's heading — after an auto-advance it had
     fallen to <body> (the next option up to 39 Tabs away) and a screen reader heard nothing. Only when focus was in the builder or on
     <body>, never on the first render. */
  var shownStep = null;
  function renderStep(o) {
    $$('.q').forEach(function (qEl) { qEl.hidden = qEl.dataset.step !== S.cur; });
    if (shownStep !== null && shownStep !== S.cur) {
      var ae = document.activeElement, h = $$('.q[data-step="' + S.cur + '"] h2')[0];
      if (h && (!ae || ae === document.body || root.contains(ae))) { if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) {} }
    }
    shownStep = S.cur;
    renderPhoto();
    $$('.opt[data-set]').forEach(function (b) {
      var on = String(S[b.dataset.set]) === String(b.dataset.val);
      b.classList.toggle('sel', on); var hit = b.querySelector('.hit'); if (hit) hit.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.dataset.vid) { var v = anyById(b.dataset.vid), so = !!(v && !v.available); b.classList.toggle('so', so); var soEl = b.querySelector('.so'); if (soEl) soEl.hidden = !so; }
    });
    $$('.chip[data-set]').forEach(function (c) {
      var set = c.dataset.set, val = c.dataset.val, on = String(S[set]) === String(val), off = false, so = false;
      if (c.dataset.vid) { var v = anyById(c.dataset.vid); so = !!(v && !v.available); }
      if (set === 'outlet') { var av = adapterVariant(S.bottle, val); off = !av; so = !!(av && !av.available); }
      if (set === 'bottle') { var outs = adapterOutletsFor(val); off = !outs.length; so = outs.length > 0 && !outs.some(function (x) { return x.available; }); }
      if (set === 'col') { if (S.len) { var tv = find('tubing', function (x) { return low(x.o[0]) === low(val) && low(x.o[1]) === low(S.len); }); so = !!(tv && !tv.available); } }
      c.classList.toggle('sel', on); c.classList.toggle('off', off); c.classList.toggle('so', so);
      c.setAttribute('aria-pressed', on ? 'true' : 'false'); c.disabled = off;
      var soEl = c.querySelector('.so'); if (soEl) soEl.hidden = !so;
    });
    $$('[data-show]').forEach(function (el) {
      var c = el.dataset.show.split(':'), on = c.length > 1 ? String(S[c[0]]) === c[1] : !!S[c[0]];
      el.hidden = !on;
    });
    $$('[data-hide]').forEach(function (el) {
      var c = el.dataset.hide.split(':');
      el.hidden = c.length > 1 ? String(S[c[0]]) === c[1] : !!S[c[0]];
    });
    $$('[data-tanks]').forEach(function (el) { el.hidden = el.dataset.tanks !== (S.tanks === 'many' ? 'many' : 'one'); });
    $$('[data-plural]').forEach(function (el) { el.hidden = (el.dataset.plural === 'one') !== (S.extra === 1); });
    setText(root, '.js-tanks', String(1 + S.extra));
    setText(root, '.js-extra', String(S.extra));
    setText(root, '.js-cnt', String(S.extra));
    var mf = first('manifold'); if (mf) setText(root, '.js-mfprice', money(mf.price * S.extra));
    var bzId = (S.diff === 'bazooka' && S.dsize) ? S.dsize : diffDefault('bazooka');
    var ioId = (S.diff === 'io' && S.dsize) ? S.dsize : diffDefault('io');
    /* 2026-09-22 (Karol: "Inline nie pokazuje ceny" — on both stores): the inline card's price is the chosen hose's variant, before the
       choice the first variant's — the card used to reveal only the Bazooka's and the IO's, so the inline one never had a price */
    var inFirst = first('diffuser_inline'), inId = (S.diff === 'inline' && S.hose) ? S.hose : (inFirst ? inFirst.id : null);
    $$('[data-vprice], [data-vlabel]').forEach(function (el) {
      var id = el.dataset.vprice || el.dataset.vlabel;
      el.hidden = !(String(id) === String(bzId) || String(id) === String(ioId) || String(id) === String(inId));
    });
    $$('[data-tog]').forEach(function (t) {
      var on = !!S[t.dataset.tog];
      t.classList.toggle('on', on);
      var hit = t.querySelector('.hit') || t; hit.setAttribute('aria-checked', on ? 'true' : 'false');
      t.classList.toggle('sel', on && t.classList.contains('chip'));
    });
    $$('[data-need]').forEach(function (el) { var n = el.dataset.need; el.hidden = n === 'canister' ? !canister() : n === 'inlineok' ? !(inlineOk() && !canister()) : n === 'inline' ? !inlineOk() : n === 'intank' ? inlineOk() : false; });
    var cards = $('[data-cards]'); if (cards) cards.classList.toggle('three', inlineOk());
    $$('[data-qty]').forEach(function (st) { setText(st, '.js-qty', String(S.qty[st.dataset.qty] || 1)); });
  }

  function cloneRow(r) {
    var t = $('.bank [data-row="' + r.row + '"]');
    if (!t) return null;
    var el = t.cloneNode(true);
    el.setAttribute('data-key', r.key || r.row);
    if (r.ctx) { setText(el, '.js-val', r.val || ''); return el; }
    setText(el, '.js-v', r.v || '');
    if (r.variant) setText(el, '.js-pr', money(r.cents));
    var qn = $('.qn', el); if (qn) { qn.hidden = !(r.qty > 1); setText(qn, '.js-q', String(r.qty)); }
    var so = $('.so', el); if (so) so.hidden = !!r.avail;
    if (!r.avail && !r.na && !r.included) el.classList.add('so');
    return el;
  }
  function renderList(o) {
    var rowsEl = $('[data-rows]'), emptyEl = $('[data-empty]');
    rowsEl.innerHTML = '';
    var parts = o.filter(function (r) { return !r.ctx; });
    emptyEl.hidden = o.length > 0;
    o.forEach(function (r) { var el = cloneRow(r); if (el) rowsEl.appendChild(el); });
    if (!S.seen.safe && parts.length) { var left = cloneRow({ row: 'left', key: 'left', avail: true }); if (left) rowsEl.appendChild(left); }
  }
  function renderReview(o) {
    var cond = $('[data-cond]'), rev = $('[data-rev]');
    cond.innerHTML = ''; rev.innerHTML = '';
    o.forEach(function (r) {
      var el = cloneRow(r); if (!el) return;
      (r.ctx ? cond : rev).appendChild(el);
    });
    if (!S.seen.safe) { var left = cloneRow({ row: 'left', key: 'left', avail: true }); if (left) rev.appendChild(left); }
    $$('[data-summsg]').forEach(function (p) {
      var want = S.added ? 'added' : (S.inCart ? 'changed' : 'idle');
      p.hidden = p.dataset.summsg !== want;
    });
  }
  function renderBar(i, o) {
    var cents = total(o), n = partCount(o), done = S.cur === 'done';
    setText(root, '.js-tot', money(cents));
    setText(root, '.js-n', String(n));
    $$('[data-pc]').forEach(function (e) { var k = e.dataset.pc; e.hidden = !((k === 'none' && n === 0) || (k === 'one' && n === 1) || (k === 'many' && n > 1)); });
    $('.step').hidden = done;
    $$('[data-stepn]').forEach(function (e) { e.hidden = (e.dataset.stepn === 'done') !== done; });
    setText(root, '.js-step', String(i + 1));
    renderSteps(i, done);
    $('[data-nav="back"]').hidden = (S.cur === 'tank');
    var tally = $('[data-sheet]'); tally.hidden = done; tally.disabled = (n === 0);

    var act = $('[data-act]'), label, added = false, dis = false;
    if (!done && S.cur !== 'safe') { label = 'continue'; dis = !ok(S.cur); }
    else if (!done) { label = 'review'; dis = !ready(); }
    else if (S.busy) { label = 'busy'; dis = true; }
    else if (soldOut(o)) { label = 'soldout'; dis = true; }
    else if (S.added) { label = 'ok'; added = true; dis = true; }
    else { label = S.inCart ? 'update' : 'add'; }
    /* 2026-09-17 (Karol: the theme's own buttons in the builder): toggle the one state class instead of rewriting className —
       the button now carries the theme's `button button--primary`, and a full rewrite stripped them on the first render. */
    act.classList.toggle('ok', added); act.disabled = dis; act.dataset.actState = label;
    $$('[data-act-label]', act).forEach(function (s) { s.hidden = s.dataset.actLabel !== label; });
  }
  /* the seven segments at the top (session 6): done = green and a button back, current = ink, the rest wait */
  function renderSteps(i, done) {
    $$('.steps-item').forEach(function (li, k) {
      var id = li.dataset.stepi, btn = li.querySelector('.steps-btn'), isDone = done || k < i, isCur = !done && id === S.cur;
      li.classList.toggle('is-done', isDone); li.classList.toggle('is-cur', isCur);
      btn.disabled = !(S.seen[id] && !isCur);
      if (isCur) btn.setAttribute('aria-current', 'step'); else btn.removeAttribute('aria-current');
    });
    $$('.steps-name').forEach(function (b) { b.hidden = b.dataset.stepname !== (done ? 'done' : S.cur); });
    var of = $('.steps-of'); if (of) of.hidden = done;
    setText(root, '.js-step2', String(i + 1));
  }
  function renderRoute() {
    var r = route();
    $$('[data-route]').forEach(function (el) { el.hidden = el.dataset.route !== r; });
  }

  /* ── the answers ───────────────────────────────────────────────────────── */
  function changed() { S.added = false; showErr(''); }
  function reconcileAdapter(from) {
    if (S.conn !== 'alt') return;
    var all = vs('adapter');
    if (!S.bottle && !S.outlet && all.length) { var a = all.filter(function (v) { return v.available; })[0] || all[0]; S.bottle = a.o[0]; S.outlet = a.o[1]; return; }
    if (adapterVariant(S.bottle, S.outlet)) return;
    if (from === 'outlet') {
      var withOut = all.filter(function (v) { return low(v.o[1]) === low(S.outlet); });
      var b = withOut.filter(function (v) { return v.available; })[0] || withOut[0];
      if (b) S.bottle = b.o[0];
    } else {
      var outs = adapterOutletsFor(S.bottle);
      var oo = outs.filter(function (v) { return v.available; })[0] || outs[0];
      if (oo) S.outlet = oo.o[1];
    }
  }
  function set(k, v) {
    changed();
    if (k === 'filter') {
      var was = route(); S.filter = v;
      if (S.diff === 'inline' && !inlineOk()) { S.diff = null; S.hose = null; }
      if (route() !== was) { S.dsize = null; S.dauto = true; }
    }
    else if (k === 'size') {
      S.size = v;
      if (S.dauto && S.diff) S.dsize = diffDefault(S.diff);
      if (S.uauto) S.ubend = S.seen.run ? ubendDefault() : null;
    }
    else if (k === 'conn') { S.conn = v; reconcileAdapter('conn'); }
    else if (k === 'bottle') { S.bottle = v; reconcileAdapter('bottle'); }
    else if (k === 'outlet') { if (!adapterVariant(S.bottle, v)) return; S.outlet = v; }
    else if (k === 'tanks') {
      S.tanks = v; S.extra = v === 'many' ? Math.max(1, S.extra) : 1;
      if (v === 'many') S.reg = 'elite';
      if (S.dqauto) S.qty.df = aquariums();
    }
    else if (k === 'reg') {
      if (v === 'prose' && S.tanks === 'many') { S.tanks = 'one'; S.extra = 1; if (S.dqauto) S.qty.df = 1; }   /* the Pro-SE feeds one aquarium: picking it takes the buyer back to one (Karol, session 6 — it used to refuse the click) */
      S.reg = v; if (!S.tanks) S.tanks = 'one';
    }
    else if (k === 'diff') { S.diff = v; if (v !== 'inline' && S.dauto) S.dsize = diffDefault(v); }
    else if (k === 'dsize') { S.dsize = v; S.dauto = false; }
    else if (k === 'ubend') { S.ubend = v; S.uauto = false; }
    else S[k] = v;
    render();
    autoAdvance(k, v);
  }
  /* a single choice that completes its step carries the buyer on (Karol, session 6: "wybranie rozmiaru akwarium nie przenosi na
     kolejny krok"); the adapter route stays on its step, its panel needs two more choices. 340 ms so the tick is seen first. */
  var AUTO = { tank: 'size', cyl: 'conn', filter: 'filter' };
  function autoAdvance(k, v) {
    if (AUTO[S.cur] !== k || !ok(S.cur) || (k === 'conn' && v === 'alt')) return;
    var from = S.cur;
    setTimeout(function () { if (S.cur !== from || !ok(from)) return; S.cur = STEPS[Math.min(STEPS.length - 1, STEPS.indexOf(from) + 1)]; render(); }, 340);
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-set],[data-tog],[data-inc],[data-incq],[data-nav],[data-go],[data-act],[data-sheet],[data-closesheet]');
    if (!t || !root.contains(t) || t.disabled) return;
    if (e.target.closest('.sub') && !t.closest('.sub')) return;
    if (e.target.closest('.what')) return;   /* the filter cards' "What is this?" folds open; it never chooses the filter (2026-09-23) */
    if (t.dataset.closesheet !== undefined) { closeSheet(); return; }
    if (t.dataset.sheet !== undefined) { openSheet(); return; }
    if (t.dataset.act !== undefined) {
      var st = t.dataset.actState;
      if (st === 'continue') { var j = STEPS.indexOf(S.cur); S.cur = STEPS[Math.min(STEPS.length - 1, j + 1)]; return render(); }
      if (st === 'review') { S.cur = 'done'; return render(); }
      if (st === 'add' || st === 'update') addSystem(t);
      return;
    }
    if (t.dataset.go) { S.cur = t.dataset.go; closeSheet(); return render(); }
    if (t.dataset.set !== undefined) return set(t.dataset.set, t.dataset.val);
    if (t.dataset.tog) { S[t.dataset.tog] = !S[t.dataset.tog]; changed(); return render(); }
    if (t.dataset.inc) { S.extra = Math.min(5, Math.max(1, S.extra + Number(t.dataset.inc)));   /* up to 5 manifolds = 6 aquariums (the team, 2026-09-11; was 3) */ if (S.dqauto) S.qty.df = aquariums(); changed(); return render(); }
    if (t.dataset.incq) { var st = t.closest('[data-qty]'), k = st && st.dataset.qty; if (k) { S.qty[k] = Math.min(9, Math.max(1, (S.qty[k] || 1) + Number(t.dataset.incq))); if (k === 'df') S.dqauto = false; changed(); render(); } return; }
    if (t.dataset.nav === 'back') {
      var i = STEPS.indexOf(S.cur);
      S.cur = S.cur === 'done' ? 'safe' : STEPS[Math.max(0, i - 1)];
      return render();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSheet(); } });

  /* ── the list, opened from the bar ─────────────────────────────────────── */
  function openSheet() { $('[data-spec]').hidden = false; $('[data-sheet]').setAttribute('aria-expanded', 'true'); }
  function closeSheet() { $('[data-spec]').hidden = true; $('[data-sheet]').setAttribute('aria-expanded', 'false'); }

  /* ── the cart, as Concept's product form does it ───────────────────────── */
  function showErr(msg) { var e = $('.js-err'); if (!e) return; e.textContent = msg || ''; e.hidden = !msg; var e2 = $('.js-err2'); if (e2) e2.textContent = msg || ''; }
  function fetchConfig(type, method) { return T.utils.fetchConfig(type, method); }
  function bundledSections() {
    var arr = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: arr } }));
    return arr;
  }
  function fetchCart() { return fetch(T.routes.cart_url, fetchConfig('json', 'GET')).then(function (r) { return r.json(); }); }
  function addItems(items, source, button) {
    var sections = bundledSections();
    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname });
    return fetch(T.routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        if (parsed.status) {
          T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartError, { source: source, productVariantId: items[0] && items[0].id, errors: parsed.errors || parsed.description, message: parsed.message });
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: parsed.description } }));
          var err = new Error(parsed.description || parsed.message || 'cart'); err.parsed = parsed; throw err;
        }
        return fetchCart().then(function (cartJson) {
          cartJson.sections = parsed.sections;
          T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: source, productVariantId: items[0] && items[0].id, cart: cartJson });
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') drawer.show(button);
          return parsed;
        });
      });
  }
  /* zero every line that carries _builder — by line-item key, one request; other lines are never touched */
  function removeBuilderLines() {
    return fetchCart().then(function (cart) {
      var updates = {}, n = 0;
      (cart.items || []).forEach(function (it) { if (it.properties && it.properties._builder) { updates[it.key] = 0; n++; } });
      if (!n) return cart;
      var config = fetchConfig('json');
      config.body = JSON.stringify({ updates: updates });
      return fetch(T.routes.cart_update_url, config).then(function (r) { return r.json(); });
    });
  }
  function addSystem(button) {
    var o = spec(), items = cartItems(o);
    if (!items.length || soldOut(o) || S.busy) return;
    S.busy = true; showErr(''); render();
    var step = S.inCart ? removeBuilderLines() : Promise.resolve();
    step.then(function () { return addItems(items, 'system-builder', button); })
      .then(function () { S.busy = false; S.added = true; S.inCart = true; render(); })
      .catch(function (err) { S.busy = false; render(); showErr((err && err.message) || ''); });
  }

  /* ── the ready-made kits: Concept's x-modal (KitsModal-<section>, opened by the builder's button through aria-controls —
     the X, the backdrop, Escape, the swipe and the scroll lock are the theme's) lists the four kits; a kit closes that modal and
     opens its quick view (the composer — the parts, their sizes, one Add to cart that adds the parts as _kit lines), never the kit
     SKU and never the seven questions; session 6 (2026-09-11), Karol's acks. Without the custom elements the kit page opens. ── */
  function kitsModal() { return document.getElementById('KitsModal-' + (root.dataset.sectionId || '')); }
  function openKitQuickView(btn) {
    var qv = document.getElementById(btn.dataset.kitqv), km = kitsModal();
    if (!qv || typeof qv.show !== 'function') { if (btn.dataset.kiturl) window.location.href = btn.dataset.kiturl; return; }
    var closing = km && km.hasAttribute('open') && typeof km.hide === 'function' ? km.hide() : null;
    Promise.resolve(closing).then(function () { qv.show(btn); });
  }
  if (kitsModal()) kitsModal().addEventListener('click', function (e) { var t = e.target.closest('[data-kitqv]'); if (t && !t.disabled) openKitQuickView(t); });

  /* ── start ─────────────────────────────────────────────────────────────── */
  var tb0 = first('tubing'); if (tb0) S.col = tb0.o[0];
  render();
  try {
    fetchCart().then(function (c) {
      S.inCart = (c.items || []).some(function (it) { return it.properties && it.properties._builder; });
      render();
    }).catch(function () { });
  } catch (e) { }
  window.CO2Builder = { state: S, spec: spec, products: PRODUCTS };
  }
  function boot() { Array.prototype.slice.call(document.querySelectorAll('#co2-builder:not([data-ready])')).forEach(function (r) { r.dataset.ready = '1'; init(r); }); }
  window.CO2BuilderBoot = boot;
  boot();
  document.addEventListener('quickview:loaded', boot);
})();
